module.exports = __webpack_public_path__ + "img/azvi-only.7ac60217.jpg";